import { lazily } from '@mkmp/core'

const { VendorMain } = lazily(() => import('@/features/vendor‌'))

/**
 * 供应商主体页面
 */
export default [
  {
    id: Symbol('vendor'),
    path: 'vendor',
    element: <VendorMain />,
    handle: {
      code: 'vendor'
    }
  }
]
